var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.983 9.53387C11.2157 9.71983 11.5929 9.71983 11.8255 9.53387C12.0582 9.34791 12.0582 9.04642 11.8255 8.86046L8.42125 6.13947C8.1886 5.95351 7.8114 5.95351 7.57874 6.13947L4.17449 8.86046C3.94184 9.04642 3.94184 9.34791 4.17449 9.53387C4.40714 9.71983 4.78435 9.71983 5.017 9.53387L8.00163 7.14828L10.983 9.53387Z","fill":"currentColor"}));
}

ChevronUp.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
